module.exports = __webpack_public_path__ + "static/media/registraduria.5db7ee0c.png";